module.exports = __webpack_public_path__ + "01_veryshort_gray.537fb77c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/01_veryshort_gray.png
// module id = hkl4
// module chunks = 0